// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3w_WV","filesListContainer":"PosDisputesFiles_filesListContainer__1lBd9","filesButton":"PosDisputesFiles_filesButton__IgbAt"};